import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BannerSectionStyle7 from '../Section/BannerSection/BannerSectionStyle7';
import Section from '../Section';
import AppointmentSection from '../Section/AppointmentSection';
import BreadcrumbStyle2 from '../Breadcrumb/BreadcrumbStyle2';
import AboutSectionStyle2 from '../Section/AboutSection/AboutSectionStyle2';
import FeaturesSectionStyle3 from '../Section/FeaturesSection/FeaturesSectionStyle3';
import TeamSectionStyle3 from '../Section/TeamSection/TeamSectionStyle3';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL } from "../../helpers/api";


export default function DepartmentDetails() {
  pageTitle('Department Details');

  const { dname } = useParams(); // this is department name from URL
  const [department, setDepartment] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

// Step 1: Fetch department by name
useEffect(() => {
  fetch(`${BASE_URL}/department_data`)
    .then((res) => res.json())
    .then((data) => {
      const selected = data.find(
        (dept) => dept.name.toLowerCase() === dname.toLowerCase()
      );
      if (selected) {
        // Departments have no real per-department image anywhere in the
        // system (no upload field in the admin/ERP panel), so this reuses
        // the same static banner image already used elsewhere on this page
        // rather than guessing a dynamic URL that would 404 for every department.
        setDepartment({ ...selected, image: "/images/departments/Departmentsssss.jpg" });
      } else {
        setDepartment(null);
      }
      setLoading(false);
    })
    .catch((err) => {
      console.error("Error fetching department:", err);
      setLoading(false);
    });
}, [dname]);

// Fetch doctors of this department
useEffect(() => {
  if (!department) return; // wait until department is loaded

  fetch(`${BASE_URL}/doctors/doc`)
    .then((res) => res.json())
    .then((data) => {
      console.log("Doctors before filter:", data);
      console.log("Loaded department:", department);

      // Match by department name <-> doctor specialist
      const filteredDoctors = data.filter(
        (doc) =>
          doc.specialist?.toLowerCase() === department.name?.toLowerCase()
      );

      console.log("Filtered doctors:", filteredDoctors);

      const doctorList = filteredDoctors.map((doc) => ({
        imgUrl: `${BASE_URL}/DoctorsImg/${doc.picture}`,
        name: doc.name || `${doc.firstname} ${doc.lastname}`,
        designation: `${doc.specialist || ""} - ${doc.degree || ""}`,
        description: doc.short_biography || "",
        btnText: "Booking",
        availableUrl: "/",
        callUrl: "/",
        chatUrl: "/",
        btnUrl: "/appointments",
      }));

      setDoctors(doctorList);
    })
    .catch((err) => console.error("Error fetching doctors:", err));
}, [department]);




  if (loading) {
    return <p style={{ textAlign: "center" }}>Loading department...</p>;
  }

  if (!department) {
    return <p style={{ textAlign: "center" }}>No department found.</p>;
  }

  return (
    <>
      <BreadcrumbStyle2 />

      {/* Department Details */}
      <Section topMd={135} topLg={100} topXl={100}>
        <AboutSectionStyle2
          title={department.name}
          subTitle={department.description}
          imgUrl={department.image}
        />
      </Section>

      {/* Treatments Section */}
      <Section topMd={170} topLg={145} topXl={90}>
        <FeaturesSectionStyle3
          sectionTitle="Treatments"
          sectionTitleUp="MORE TYPE OF"
          data={[
            {
              title: 'Vaccinations Department',
              subTitle:
                'The Pediatric Department provides vaccinations to help protect children from a range of illnesses and diseases, including measles.',
              iconUrl: '/images/departments/icon_9.svg',
            },
            {
              title: 'Management of acute illnesses',
              subTitle:
                'The Pediatric Department provides treatment for common childhood illnesses, such as ear infections, strep throat, and viral infections.',
              iconUrl: '/images/departments/icon_10.svg',
            },
            {
              title: 'Treatment of chronic conditions',
              subTitle:
                'The Pediatric Department provides ongoing care and treatment for children with chronic conditions such as asthma, diabetes, and allergies.',
              iconUrl: '/images/departments/icon_11.svg',
            },
            {
              title: 'Developmental screenings',
              subTitle:
                'The Pediatric Department provides regular developmental screenings to identify any delays or concerns and provide early intervention services.',
              iconUrl: '/images/departments/icon_12.svg',
            },
          ]}
        />
      </Section>

{/* Related Doctor Section */}

<Section topMd={200} topLg={150} topXl={100}>
  <TeamSectionStyle3 sectionTitle="Related Doctor" data={doctors} />
</Section>

      {/* Appointment Section */}
      <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={190}
        bottomLg={145}
        bottomXl={110}
        id="appointment"
      >
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/departments/Departmentsssss.jpg"
        />
      </Section>

      {/* Footer Banner */}
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle7
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section>
    </>
  );
}